export enum MatchQuality {
  NA = 0,
  Poor,
  Fair,
  Good,
  Great,
  Excellent,
  Overqualified,
}
